<!-- Hero do Iglu 3D (Three.js): entrada + galeria de produtos na mesma seção -->
<app-igloo-hero></app-igloo-hero>

<app-footer></app-footer>
